var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "title-container"
  }, [_vm._t("title", function () {
    return [_c('label', [_vm._v(_vm._s(_vm.label))])];
  })], 2), _vm._l(_vm.options, function (option) {
    return _c('form-checkbox', {
      key: `${_vm.id}-checkbox-${option.value}`,
      staticClass: "filter-checkbox",
      attrs: {
        "id": `${_vm.id}-checkbox-${option.value}`,
        "value": _vm.checkboxValue(option.value),
        "label": option.name
      },
      on: {
        "change": function ($event) {
          return _vm.onSelectedChange($event, option);
        }
      },
      scopedSlots: _vm._u([{
        key: "icon",
        fn: function () {
          return [option.color ? _c('div', {
            staticClass: "little-circle",
            style: `background-color:${option.color}`
          }) : _vm._e()];
        },
        proxy: true
      }], null, true)
    });
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }